export default __webpack_public_path__ + "static/media/Blade of the Dark Sun.26d69ec0.jpg";